module.exports = __webpack_public_path__ + "img/youtube-placeholder.a33e3c5d.svg";